// src/themes/dark.ts
import { DefaultTheme } from 'styled-components'

const temaDark: DefaultTheme = {
  corPrincipal: '#fff',
  corSecundaria: '#aaa',
  corDeFundo: '#000',
  corDeFundoBotao: '#4d45beff',
  corDaBorda: '#fff'
}

export default temaDark
